import type { FC, ReactNode } from 'react'

import { LegalPage } from '@/components/generals/legal-page'

const TermsAndConditions: FC = (): ReactNode => {
    return (
        <LegalPage
            title='Terms and conditions'
            roman='Terms and'
            italic='Conditions'
            summary='The terms that apply when you use this website and when you commission work from the studio.'
            updated='September 2026'
            sections={[
                {
                    heading: 'About this website',
                    body: [
                        'This site describes the work and services of Astra Studio. The information on it is general, and nothing here is an offer to carry out work until a written proposal has been agreed.'
                    ]
                },
                {
                    heading: 'Enquiries and proposals',
                    body: [
                        'Submitting the enquiry form is a request, not a commission. We will reply to arrange a conversation and, where it makes sense, send a written proposal with a fixed fee and timeline.',
                        'A project begins only once the proposal has been signed and the first payment received.'
                    ]
                },
                {
                    heading: 'Scope and changes',
                    body: [
                        'Every proposal lists exactly what is included. If the scope changes, we will tell you before any extra work begins and agree the change in writing.'
                    ]
                },
                {
                    heading: 'Fees and ownership',
                    body: [
                        'Fees in a written proposal are held for sixty days. Full rights to the final work transfer to the client on final payment. Licensed typefaces and stock photography remain subject to their own licences.'
                    ]
                },
                {
                    heading: 'Content and liability',
                    body: [
                        'The text, photography and design of this site belong to Astra Studio and its clients, and may not be reproduced without permission. We take care to keep the site accurate and available, but we do not warrant that it will be uninterrupted or error free.'
                    ]
                }
            ]}
        />
    )
}

export default TermsAndConditions
